import React from 'react';
import { TrainingBlock } from './TrainingBlock';
interface LocationColumnProps {
  location: any;
  date: Date;
  trainings: any[];
  trainingTypes: any[];
  instructors: any[];
  startHour: number;
  endHour: number;
  hourHeight: number;
  onTrainingClick: (training: any) => void;
  hasOverlap: (trainingId: number) => boolean;
}
export function LocationColumn({
  location,
  date,
  trainings,
  trainingTypes,
  instructors,
  startHour,
  endHour,
  hourHeight,
  onTrainingClick,
  hasOverlap
}: LocationColumnProps) {
  const columnWidth = 100 / location.capacity;
  const calendarHeight = (endHour - startHour) * hourHeight;
  // Group trainings by time slot to detect overlaps within the same location
  const groupTrainingsByTimeSlot = () => {
    const slots = [];
    trainings.forEach(training => {
      // Find existing slot that overlaps with this training
      const overlappingSlotIndex = slots.findIndex(slot => {
        return slot.some(existingTraining => {
          return training.startTime <= existingTraining.endTime && training.endTime >= existingTraining.startTime || existingTraining.startTime <= training.endTime && existingTraining.endTime >= training.startTime;
        });
      });
      if (overlappingSlotIndex >= 0) {
        // Add to existing slot
        slots[overlappingSlotIndex].push(training);
      } else {
        // Create new slot
        slots.push([training]);
      }
    });
    return slots;
  };
  const timeSlots = groupTrainingsByTimeSlot();
  return <div className="relative border-r border-gray-200 flex-1" style={{
    minWidth: `${100 / location.capacity}px`
  }} data-id="element-3069">
      <div className="absolute top-0 left-0 w-full text-xs text-gray-500 bg-gray-50 px-2 py-1 border-b border-gray-200" data-id="element-3070">
        {location.name}
      </div>
      <div style={{
      height: `${calendarHeight}px`,
      marginTop: '24px'
    }} className="relative" data-id="element-3071">
        {/* Hour grid lines */}
        {Array.from({
        length: endHour - startHour
      }).map((_, index) => <div key={index} className="absolute border-b border-gray-200 w-full" style={{
        top: `${index * hourHeight}px`,
        height: `${hourHeight}px`
      }} data-id="element-3072" />)}
        {/* Training blocks */}
        {timeSlots.map((slot, slotIndex) => <div key={slotIndex} className="flex w-full absolute" data-id="element-3073">
            {slot.map((training, trainingIndex) => {
          const trainingType = trainingTypes.find(t => t.id === training.trainingTypeId);
          const instructor = instructors.find(i => i.id === training.instructorId);
          const startMinutes = (training.startTime.getHours() - startHour) * 60 + training.startTime.getMinutes();
          const endMinutes = (training.endTime.getHours() - startHour) * 60 + training.endTime.getMinutes();
          const durationMinutes = endMinutes - startMinutes;
          const top = startMinutes / 60 * hourHeight;
          const height = durationMinutes / 60 * hourHeight;
          // Calculate width based on how many trainings are in this slot
          const width = 100 / slot.length;
          const left = trainingIndex * width;
          return <TrainingBlock key={training.id} training={training} trainingType={trainingType} instructor={instructor} style={{
            top: `${top}px`,
            height: `${height}px`,
            width: `${width}%`,
            left: `${left}%`
          }} hasOverlap={hasOverlap(training.id)} onClick={() => onTrainingClick(training)} data-id="element-3074" />;
        })}
          </div>)}
      </div>
    </div>;
}